import type { RescheduleCandidateOut } from "@/__generated__/api/wrenAPI.schemas";

export function RescheduleSlotContent({ slot }: { slot: RescheduleCandidateOut }) {
  const start = new Date(slot.start_utc);
  const end = new Date(slot.end_utc);
  const date = new Intl.DateTimeFormat("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    timeZone: slot.display_tzid,
  }).format(start);
  const startTime = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit",
    timeZone: slot.display_tzid,
  }).format(start);
  const endTime = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit",
    timeZone: slot.display_tzid,
    timeZoneName: "short",
  }).format(end);

  return (
    <span className="flex flex-col gap-0.5">
      <span className="font-medium text-primary">{date}</span>
      <span className="[font:var(--type-caption)] text-secondary">{startTime}–{endTime}</span>
    </span>
  );
}
